import { NgModule } from '@angular/core';

import { UserRoutingModule } from './user.routing';
import { ListUserComponent } from './list-user/list-user.component';
import { UserFormComponent } from './components/user-form/user-form.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { UpdateUserComponent } from './update-user/update-user.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ListUserComponent, UserFormComponent, CreateUserComponent, UpdateUserComponent],
  imports: [SharedModule, UserRoutingModule]
})
export class UserModule {}
